export const routesDirectadminEmail = [
  {
    path: "/panel_email",
    name: "panel_email",
    component: () => import("@/views/directadmin_email/index.vue"),
    meta: {
      public: false,
      title: "Panel Email",
      yetki: { k: [1070002] },
    },
  },
]
